module.exports = __webpack_public_path__ + "img/coreSurge.7b095f72.png";